/**
 * description 音频弹窗控制器
 * created by ge.yuankai
 * created on 2018-04-17
 */
"use strict";
angular.module("insertAudioModule", []).controller("insertAudioCtrl", [
  "$scope",
  "$element",
  "$stateParams",
  "$q",
  "$modalInstance",
  "$compile",
  "$state",
  "httpService",
  "modalDialog",
  "ueditorService",
  "$validation",
  "localStorageService",
  "$timeout",
  "$sce",
  "$interval",
  "Upload",
  function (
    $scope,
    $element,
    $stateParams,
    $q,
    $modalInstance,
    $compile,
    $state,
    httpService,
    modalDialog,
    ueditorService,
    $validation,
    localStorageService,
    $timeout,
    $sce,
    $interval,
    Upload
  ) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
      $scope.srcaudio = "";
      $scope.status = {
        audiosData: [], //音频数据的集合
        ueditorProgress: "0", //上传进度
        libType_a: 201, //audio的libtype
        uploadSuccess: false, //音频是否上传成功
        transcoding: false, //音频是正在转码
        transcodSuccess: false, //音屏是否转码成功
        uploadError: false, //音频是否上传失败
        audioUrl: "", //音频的播放地址
        uploadAudioUrl: "", //媒资音频上传的地址
        isClose: false, //弹窗是否关闭
      };
      $scope.data = {};
      // loadUploadIframe();
    }

    function initData() {}
    $scope.cancel = function () {
      $scope.status.isClose = true;
      clearaudioEventListener();
      $modalInstance.dismiss();
      clearalltimeout();
      $scope.deleteaudio();
    };
    /**
     * [uploadaudio description]初始化上传至吉木萨尔县在线的音频的方法
     * @return {[type]} [description]
     */
    $scope.uploadaudio = function (files, file, newFiles) {
      if (!file) return;
      if (newFiles.length != 0) {
        newFiles = packageAudioList(newFiles);
        angular.forEach(newFiles, function (file, index) {
          if ($scope.status.audiosData[index].success) return;
          Upload.upload({
            url: "/mcnww/upload/audio.do",
            headers: { requestToken: sessionStorage.getItem("requestToken") },
            data: {
              file: newFiles[index],
            },
          }).then(
            function (resp) {
              if (resp.data.success) {
                $scope.uploadsuccess = $timeout(function () {
                  // uploadSuccess:false,//视频是否上传成功
                  // uploadError:false,//视频是否上传失败
                  // transcoding:false,//视频正在转码
                  // transcodSuccess:false,//视屏是否转码成功
                  // transcodError:false,//视频是否转码失败
                  $scope.status.uploadError = false;
                  $scope.status.transcoding = false;
                  $scope.status.uploadSuccess = true;
                  $scope.status.transcodSuccess = true;
                  $scope.transcodError = false;
                  $scope.status.audiosData[index] = resp.data;
                }, 10);
              } else {
                $scope.uploadfail = $timeout(function () {
                  $scope.status.uploadError = true;
                  $scope.status.transcoding = false;
                  $scope.status.uploadSuccess = false;
                  $scope.status.transcodSuccess = false;
                  $scope.transcodError = false;
                  $(".speed")
                  .find(".exhibition .ex_jindu")
                  .css("width", "0%");
                }, 10);
              }
            },
            function (resp) {
              $scope.uploadfail2 = $timeout(function () {
                $scope.status.uploadError = true;
                $scope.status.transcoding = false;
                $scope.status.uploadSuccess = false;
                $scope.status.transcodSuccess = false;
                $scope.transcodError = false;
                // $scope.status.ueditorProgress = 0;
                $(".speed")
                  .find(".exhibition .ex_jindu")
                  .css("width","0%");
              }, 10);
            },
            function (evt) {
              $scope.uploadjindu = $timeout(function () {
                $scope.status.ueditorProgress = parseInt(
                  (100.0 * evt.loaded) / evt.total
                );
                $scope.status.uploadError = false;
                // $scope.progressStyle = {
                //     width: $scope.ProgressBar
                // };
                $scope.status.transcoding = true;
                $(".speed")
                  .find(".exhibition")
                  .css("width", $scope.ueditorProgress * 0.75 + "%");
              });
            }
          );
        });
      }
    };

        /**
     * [clearalltimeout description]清除所有定时器
     *
     * @return  {[type]}  [return description]
     */
    function clearalltimeout() {
      $timeout.cancel($scope.uploadjindu);
      $timeout.cancel($scope.uploadfail2);
      $timeout.cancel($scope.uploadfail);
      $timeout.cancel($scope.uploadsuccess);
    }

    /**
     * [packagePicList description] 组装音频列表
     * @return {[type]} [description]
     */
    function packageAudioList(files) {
      var tempFiles;
      tempFiles = $scope.status.audiosData.concat(files);

      for (var i in files) {
        var file = files[i];
        var obj = {
          original: file, //把原始的file保存起来
          imgSrc: URL.createObjectURL(file),
          display: "inline-block",
        };
        $scope.status.audiosData.push(obj);
      }
      return tempFiles;
    }

    function uploadaudio() {
      document
        .getElementById("ueditoraudioUpload")
        .contentWindow.postMessage("upload", "/");
      audioeventListener(); //音频启动监听
    }
    /**
     * [audioeventListener description] postMessage音频信息监听
     * @return {[type]} [description]
     */
    function audioeventListener() {
      clearaudioEventListener(); //先清除
      $scope.status.uploadBoxShow = false;
      //保存音音频
      window.addEventListener("message", audiotheEvent, false);
    }
    /**
     * [clearaudioEventListener description] 清除音频监听服务
     * @return {[type]} [description]
     */
    function clearaudioEventListener() {
      if (angular.isFunction(audiotheEvent)) {
        window.removeEventListener("message", audiotheEvent, false);
      }
    }
    /**
     * [audiotheEvent description] 音频监听事件方法
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    function audiotheEvent(e) {
      if (!!e && angular.isString(e.data) && e.data.indexOf("audio") > -1) {
        var msg = e.data;
        //判断是否是正确格式
        if (msg.indexOf("progress") > -1) {
          $timeout(function () {
            $scope.status.ueditorProgress = e.data.split("=")[1];
          });
        } else if (msg.indexOf("complete") > -1) {
          $scope.status.uploadSuccess = true; //先显示上传成功
          var vId = e.data.split("=")[1]; //获得音频id
          saveVideo(vId).then(function (data) {
            if (data.code == 0) {
              $scope.status.transcoding = true; //先显示视屏正在转码
              // downLoadaudio(vId);
              audiotimer(vId); //音频上传完之后 先查询稿件的转码信息
            }
          });
        } else if (msg.indexOf("type") > -1) {
          modalDialog.alertType(
            "上传失败",
            "请选择正确的音频格式，再上传！",
            "warning",
            "confirm",
            function () {
              $scope.deleteaudio();
              clearalltimeout();
            }
          );
          return;
        }
      }
    }
    $scope.deleteaudio = function () {
      document
        .getElementById("ueditoraudioUpload")
        .contentWindow.postMessage("delete", "/");
      clearaudioEventListener(); //清除音频监听
      $scope.status.ueditorProgress = "0"; //上传进度清零
      $scope.status.uploadSuccess = false; //音频是否上传成功
      $scope.status.uploadError = false; //音频是否上传失败
      $scope.status.transcoding = false; //音频正在转码
      $scope.status.transcodSuccess = false; //音屏是否转码成功
      $scope.status.audioUrl = ""; //音频的播放地址
      $scope.status.audiosData = [];
      $scope.status.isClose = true;
    };
    /**
     * [videotimer description] 音频定时刷新
     * @param  {[type]} dataId [description]
     * @return {[type]}        [description]
     */
    function audiotimer(vId) {
      var timer = $interval(function () {
        httpService
          .http(
            "/mcnww/web/cloud/getVideoStatus.do",
            { id: vId, libType: $scope.status.libType_a },
            "get"
          )
          .then(function (data) {
            if (data.code === 0) {
              if (data.data.code === 0) {
                $interval.cancel(timer);
                $scope.status.transcoding = false;
                $scope.status.transcodSuccess = true;
                downLoadaudio(vId);
              }
            }
          });
      }, 3000);
    }
    /**
     * [saveVideo description] 保存音视屏
     * @param  {[type]} dataId [description]
     * @return {[type]}        [description]
     */
    function saveVideo(vId) {
      var deffer = $q.defer();
      httpService
        .http(
          "/mcnww/web/cloud/saveVideo.do",
          { id: vId, libType: $scope.status.libType_a },
          "get"
        )
        .then(function (data) {
          // debugger;
          deffer.resolve(data);
        });
      return deffer.promise;
    }
    /**
     * [downLoadaudio description] 获取音频的播放地址
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    function downLoadaudio(vId) {
      httpService
        .http(
          "/mcnww/web/cloud/getVideoUrl.do",
          { id: vId, libType: $scope.status.libType_a },
          "get"
        )
        .then(function (data) {
          if (data.data.videoUrl) {
            $scope.status.audioUrl = $sce.trustAsResourceUrl(
              data.data.videoUrl
            );
            var obj = {
              id: vId,
              audioUrl: data.data.videoUrl,
              audioName: data.data.filename,
            };
            $scope.status.audiosData.push(obj); //把音频的数据放到数组中 防止以后拓展多音频上传
          }
        });
    }
    /**
     * [loadUploadIframe description] 加载上传音音频的iframe
     * @return {[type]} [description]
     */
    function loadUploadIframe() {
      $.ajax({
        url: "/mcnww/web/cloud/audioUpload.do",
        type: "post",
        headers: { requestToken: sessionStorage.getItem("requestToken") },
        data: "",
        datatype: "text",
        success: function (data) {
          var urlarr = data.split("/");
          urlarr.splice(0, 3);
          $scope.srcaudio = "/" + urlarr.join("/");
          // data = data.replace(/http:\/\/testqiniu.tmuyun.com:8080/, "");
          // $scope.srcaudio = data;
          // $scope.status.uploadAudioUrl = data.split("?")[0];
          // $scope.srcaudio = $sce.trustAsResourceUrl($scope.srcaudio);
        },
      });
    }
    /**
     * [confirm] 确认
     * @return {[type]} [description]
     */
    $scope.confirm = function () {
      if (!$scope.status.uploadSuccess) {
        modalDialog.alertType(
          "",
          "音频正在上传中，请等待上传结束",
          "warning",
          "confirm"
        );
        return;
      }
      if (!$scope.status.transcodSuccess) {
        modalDialog.alertType(
          "",
          "视频正在处理中，请等待处理结束",
          "warning",
          "confirm"
        );
        return;
      }
      //获取播放音频的图片 传给编辑器
      // httpService.http("/mcnww/web/cloud/getMediaFrame.do", {id:$scope.status.audiosData[0].id, libType: $scope.status.libType_a }, "get").then(function(data) {
      // 	var data = {
      // 		// id:$scope.status.audiosData[0].id,
      // 		// imgUrl:data.data.mediaFrameUrl,
      // 		audioUrl:$scope.status.audiosData[0].audioUrl,
      // 		// audioName:$scope.status.audiosData[0].audioName
      // 	};
      // 	$scope.status.isClose = true;
      // 	$modalInstance.close(data);
      // });
      var data = {
        // id:$scope.status.audiosData[0].id,
        // imgUrl:data.data.mediaFrameUrl,
        audioUrl: $scope.status.audiosData[0].url,
        // audioName:$scope.status.audiosData[0].audioName
      };
      $scope.status.isClose = true;
      $modalInstance.close(data);
      $scope.deleteaudio();
    };
  },
]);
